import * as R from "ramda";
import BannedWordsJSON from "./banned_words.json";

const WordsJSON = await import('./words.json').then(module => module.default);

export const words: string[] = WordsJSON as unknown as string[];
// export const WordsObject: {
//   [key: string]: number;
// } = WordsJSON as unknown as { [key: string]: number };
export const WordsSet = new Set(words);

export const BannedWordsObject: {
  [key: string]: number;
} = R.zipObj(BannedWordsJSON, R.repeat(1, BannedWordsJSON.length));

